<template>

    <div :id="id" class="hello w-100 mb-2 rounded-2" ref="chartdiv"></div>

</template>

<script>
/* eslint-disable */
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import api from '@/services/api'

import rangesData from "@/assets/globalVar.json";

import riskData from "@/views/app.json"
import opportData from "@/views/app_opport.json"



export default {
    emits: ['sortDone'],
    props: {
        id: {
            type: String,
            required: true
        },
        regions: {
            type: Array,
            required: true
        },
        regionsSelected: {
            type: String,
            required: true
        },
        countriesData: {
            type: Object,
            required: true
        },
        IndicatorSelected: {
            type: String,
            required: true
        },
        flipped: {
            type: Boolean,
            required: false
        },
        disableTitle: {
            type: Boolean,
            required: true
        },
        sort: {
            type: Boolean,
            required: false
        },
        arbitraryOrder: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: [],
            selectedCountry: null,
            indicatorData: {},
            indicatorName: null,
            countryData: null,
            chart: null,
            series: null,
            xAxis: null
        }
    },
    watch: {
        sort: {
            handler: function () {
                if (this.sort) {
                    // this.chart.events.once("inited", () => {
                    this.sortCategoryAxis()
                    // })
                    this.$emit('sortDone', this.getCurrentOrder())
                }

            },
            deep: true,
        },
        arbitraryOrder: {
            handler: function (val) {
                if (val.length > 0) {
                    this.sortByArbitraryOrder(val)
                    this.$emit('arbitrarySortDone')
                }
            }
        }
    },
    methods: {
        getColor(value) {

            let ranges = []

            if (riskData.find(({ code }) => code.includes(this.IndicatorSelected))) {
                ranges = rangesData.risk
            }
            if (opportData.find(({ code }) => code.includes(this.IndicatorSelected))) {
                ranges = rangesData.opport
            }

            if (value >= 5) {
                return ranges[4].color;
            } else {
                for (let i = 0; i < ranges.length; i++) {
                    if (value >= ranges[i].rangeMin - 0.005 && value <= ranges[i].rangeMax - 0.005) {
                        return ranges[i].color;
                    }
                }
            }

        },
        async getIndicator() {
            try {

                let url = `data/ssind/${this.IndicatorSelected}?start_date=2025-01-01&end_date=2025-12-31`
                const reponse = await api.get(url)
                this.indicatorData = await reponse.data

                this.indicatorData.data.forEach(indicator => {
                    this.data.forEach(country => {
                        if (indicator.country_name == country.country) {
                            country.value = Math.round(indicator.myvalue * 10) / 10
                        }
                    })
                })
            } catch (error) {
                console.error('Erreur lors de la récupération des données : ', error)
            }
        },
        selectedIndicator() {
            if (this.$route.params.indicator) {
                const indicator = this.$route.params.indicator.split('?')
            }
        },
        parseRegion() {
            this.selectedCountry = this.regionsSelected;
            if (this.selectedCountry) {
                const indexVirgule = this.selectedCountry.indexOf(',');
                if (indexVirgule !== -1) {
                    this.selectedCountry = this.selectedCountry.split(',').map(country => country.trim());
                }
            }
            // this.selectedIndicator()
            this.parseCountryInRegion()
        },
        parseCountryInRegion() {
            if (this.selectedCountry && this.selectedCountry.length > 0) {
                const countriesArray = this.countriesData.data;

                const countryNames = countriesArray.filter(country => {
                    return this.selectedCountry.includes(country.country_name);
                }).map(selected => ({
                    country: selected.country_name,
                    value: 4,
                }));



                this.data_country_final = countryNames;

            }
            if (this.selectedCountry) {
                const regionsWithCountries = {};
                const countriesArray = this.countriesData.data;

                const selectedRegions = Array.isArray(this.selectedCountry)
                    ? this.selectedCountry
                    : [this.selectedCountry];

                selectedRegions.forEach(region => {
                    const countriesInRegion = countriesArray.filter(country => {
                        return country.region_name === region;
                    });
                    const countryNamesInRegion = countriesInRegion.map(country => ({
                        country: country.country_name,
                        value: 4,
                    }));
                    regionsWithCountries[region] = countryNamesInRegion;
                });
                const additionalData = selectedRegions.reduce((acc, region) => {
                    return acc.concat(regionsWithCountries[region] || []);
                }, []);
                this.data = this.data.concat(additionalData).concat(this.data_country_final);
                const uniqueCountries = Array.from(new Set(this.data.map(item => item.country)));
                this.data = uniqueCountries.map(country => ({
                    country,
                    value: 4,
                }));

                for (let i = 0; i < this.data.length; i++) {
                    for (let j = 0; j < this.countryData.data.length; j++) {
                        if (this.data[i].country == this.countryData.data[j].country_name) {

                            this.data[i]["country_id"] = this.countryData.data[j].country_id
                        }
                    }
                }


            } else {
                this.data = [];
            }
        },
        async renderChart() {
            let root = am5.Root.new(this.$refs.chartdiv);
            root._logo.dispose()
            root.setThemes([
                am5themes_Animated.new(root)
            ]);

            this.chart = root.container.children.push(am5xy.XYChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "none",
                wheelY: "none",
                paddingTop: 0,
                marginTop: 0,
                paddingBottom: 0,
                marginBottom: 0,
                valign: 'top',
                contentValign: 'top',
                // layout: root.verticalLayout
            }));

            this.chart._settings.paddingTop = 0

            this.chart.zoomOutButton.set("forceHidden", true);

            let xRenderer = am5xy.AxisRendererX.new(root, {
                minGridDistance: 0
            });



            xRenderer.labels.template.setAll({
                rotation: 0,
                centerY: am5.p50,
                centerX: am5.p50,
                maxWidth: 150,
            });


            xRenderer.grid.template.set("visible", false);

            this.xAxis = this.chart.xAxes.push(am5xy.CategoryAxis.new(root, {
                maxDeviation: 0.3,
                categoryField: "country_id",
                renderer: xRenderer,
                minGridDistance: 0,
                min: 0,
                strictMinMax: true
            }));

            if (this.disableTitle && this.flipped) {
                this.xAxis.get("renderer").labels.template.set("visible", false);
            }

            // xAxis.get("renderer").labels.template.adapters.add("html", (text, target) => {
            //     const dataItem = target.dataItem;
            //     if(dataItem){
            //         let html = "<p style=\"height:50px; vertical-align: center\">"+dataItem._settings.category+"</p>"

            //         return "a"
            //     }
            // })


            this.xAxis.onPrivate("cellWidth", function (cellWidth) {
                let rotated = false;
                xRenderer.labels.each(function (label) {
                    if (label.width() > cellWidth) {
                        rotated = true;
                    }
                });


                xRenderer.labels.template.setAll({
                    // rotation: -45,
                    centerX: am5.p50,
                    fontsize: 10
                })

            });



            let yAxis = this.chart.yAxes.push(am5xy.ValueAxis.new(root, {
                inversed: true,
                maxDeviation: 0.3,
                min: 1,
                max: 5,
                calculateTotals: true,
                maxPrecision: 0,
                strictMinMax: true,
                renderer: am5xy.AxisRendererY.new(root, {
                    inversed: this.flipped
                })
            }));


            this.series = this.chart.series.push(am5xy.ColumnSeries.new(root, {
                name: "Series 1",
                xAxis: this.xAxis,
                yAxis: yAxis,
                valueYField: "value",
                categoryXField: "country_id",
            }));

            let labelLowY;
            let labelHighY;
            let labelLowText;
            let labelHighText;
            let labelLowX;
            let labelHighX;
            let labelHighColor
            let labelLowColor

            if (riskData.find(({ code }) => code.includes(this.IndicatorSelected))) {

                labelLowText = "Lower Risk"
                labelHighText = "Higher Risk"
                labelHighColor = am5.color("#cc0000")
                labelLowColor = am5.color("#029602")



                if (this.flipped) {
                    labelLowY = am5.percent(30)
                    labelHighY = am5.percent(80)
                    labelLowX = 20
                    labelHighX = 20

                } else {
                    labelLowY = am5.percent(95)
                    labelHighY = am5.percent(10)
                    labelLowX = -20
                    labelHighX = -20
                }
            }
            if (opportData.find(({ code }) => code.includes(this.IndicatorSelected))) {
                labelLowText = "Lower Opportunity"
                labelHighText = "Higher Opportunity"

                labelHighColor = am5.color("#38761D")
                labelLowColor = am5.color("#0B5394")


                if (this.flipped) {
                    labelLowY = am5.percent(45)
                    labelHighY = am5.percent(80)
                    labelLowX = 20
                    labelHighX = 20
                } else {
                    labelLowY = am5.percent(95)
                    labelHighY = am5.percent(16)
                    labelLowX = -20
                    labelHighX = -20
                }
            }

            this.chart.children.unshift(am5.Label.new(root, {
                text: labelHighText,
                fill: am5.color("#000"),
                x: am5.percent(100),
                y: labelHighY,
                // centerY: am5.p0,
                centerX: am5.p100,
                dx: 65,
                dy: 60,
                rotation: 90,
                fill: labelHighColor
            }))
            this.chart.children.unshift(am5.Label.new(root, {
                text: labelLowText,
                fill: am5.color("#000"),
                x: am5.percent(100),
                y: labelLowY,
                dx: 30,
                rotation: 90,
                centerY: am5.p100,
                centerX: am5.p100,
                fill: labelLowColor
            }))





            this.chart.set('paddingRight', 70);
            this.chart.set('paddingLeft', 70);

            this.series.columns.template.setAll({
                cornerRadiusTL: 5,
                cornerRadiusTR: 5,
                strokeOpacity: 0
            });
            this.series.columns.template.adapters.add("fill", (fill, target) => {
                if (this.getColor(target.dataItem.get("valueY"))) {
                    return am5.color(this.getColor(target.dataItem.get("valueY")))
                } else {
                    return am5.color("#000")
                }
            });


            this.series.columns.template.adapters.add("stroke", (stroke, target) => {
                return this.chart.get("colors").getIndex(this.series.columns.indexOf(target));
            });




            this.series.bullets.push(() => {

                let label = am5.Label.new(root, {
                    text: "{valueYWorking.formatNumber('#.#')}",
                    fill: am5.color("#000"),
                    centerY: 0,
                    centerX: am5.p50,
                    populateText: true,
                    dy: 0
                })

                label.adapters.add("text", (text, target) => {

                    const dataItem = target.dataItem;
                    if (dataItem.get("valueY") == 1.000001 || dataItem.get("valueY") == null) {
                        return "N/A"
                    } else {
                        return text
                    }

                })


                label.adapters.add("dy", (text, target) => {

                    const dataItem = target.dataItem;
                    if (dataItem.get("valueY") == 1.000001 || dataItem.get("valueY") == null) {
                        if (this.flipped) {
                            return 20
                        } else {
                            return -50
                        }
                    } else {
                        if (this.flipped) {
                            return -40
                        }
                    }

                })


                return am5.Bullet.new(root, {
                    locationY: 1,
                    sprite: label
                });



            });





            for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].value == 0) {
                    this.data[i].value = 1.000001
                }
            }

            this.xAxis.data.setAll(this.data);
            this.series.data.setAll(this.data);

            const resp = await api.get(`/ssind/${this.IndicatorSelected}`)
            const data = resp.data
            this.indicatorName = data.data[0].name

            if (this.disableTitle) {


                this.chart.children.unshift(am5.Label.new(root, {
                    text: this.indicatorName,
                    fontSize: 15,
                    rotation: -90,
                    dy: 300,
                    dx: -50
                }))
            }

            if (!this.disableTitle) {
                this.chart.children.unshift(am5.Label.new(root, {
                    text: this.indicatorName,
                    fontSize: 35,
                    fontWeight: "500",
                    textAlign: "center",
                    x: am5.percent(50),
                    centerX: am5.percent(50),
                    paddingTop: 0,
                    paddingBottom: 0
                }));
            }


            if (!this.disableTitle) {
                setInterval(() => {

                    if (!this.disableTitle) {
                        this.sortCategoryAxis()
                    }
                }, 1500)
            }





            this.series.appear(1000);
            this.chart.appear(1000, 100);
        },

        sortCategoryAxis() {
            this.series.dataItems.sort(function (x, y) {
                return y.get("valueY") - x.get("valueY");
            })
            am5.array.each(this.xAxis.dataItems, (dataItem) => {
                let seriesDataItem = this.getSeriesItem(dataItem.get("category"));
                if (seriesDataItem) {
                    let index = this.series.dataItems.indexOf(seriesDataItem);
                    let deltaPosition = (index - dataItem.get("index", 0)) / this.series.dataItems.length;
                    dataItem.set("index", index);
                    dataItem.set("deltaPosition", -deltaPosition);
                    dataItem.animate({
                        key: "deltaPosition",
                        to: 0,
                        duration: 1000,
                        easing: am5.ease.out(am5.ease.cubic)
                    })
                }
            });
            this.xAxis.dataItems.sort(function (x, y) {
                return x.get("index") - y.get("index");
            });
        },
        getSeriesItem(category) {
            for (var i = 0; i < this.series.dataItems.length; i++) {
                let dataItem = this.series.dataItems[i];
                if (dataItem.get("categoryX") == category) {
                    return dataItem;
                }
            }
        },
        getCurrentOrder() {
            let properOrder = []
            am5.array.each(this.xAxis.dataItems, (dataItem) => {
                let seriesDataItem = this.getSeriesItem(dataItem.get("category"));
                properOrder.push(seriesDataItem._settings.categoryX)
            })
            return properOrder
        },
        sortByArbitraryOrder(order) {
            // Sort the dataItems in the series
            this.series.dataItems.sort((x, y) => {
                return order.indexOf(x.get("categoryX")) - order.indexOf(y.get("categoryX"));
            });

            am5.array.each(this.xAxis.dataItems, (dataItem) => {
                let seriesDataItem = this.getSeriesItem(dataItem.get("category"));
                if (seriesDataItem) {
                    let index = this.series.dataItems.indexOf(seriesDataItem);
                    let deltaPosition = (index - dataItem.get("index", 0)) / this.series.dataItems.length;
                    dataItem.set("index", index);
                    dataItem.set("deltaPosition", -deltaPosition);
                    dataItem.animate({
                        key: "deltaPosition",
                        to: 0,
                        duration: 1000,
                        easing: am5.ease.out(am5.ease.cubic)
                    })
                }
            });

            this.xAxis.dataItems.sort(function (x, y) {
                return x.get("index") - y.get("index");
            });



        }

    },
    async mounted() {

        const response = await api.get('/countries');
        this.countryData = await response.data;


        this.parseRegion()
        await this.getIndicator()
        this.renderChart()

    },
}
</script>
